<template>
    <div>
        <myPage :max_flag="true">
            <div class="pd-left10 pd-bottom5" slot="header">
                <div class="flex-box nopadding wrap">
                    <el-button-group class="mg-right5 mg-top5 flex-box nopadding">
                        <el-button size="small" :title="$t('refs')" icon="el-icon-refresh" @click="list()"></el-button>
                        <el-button size="small" @click="exportExcel" :title="$t('export')" icon="el-icon-download"></el-button>
                    </el-button-group>
                    <div class="f-bd f14 text-nowrap">账期{{$t('x_mh')}}</div>
                    <div class="mg-right5 mg-top5"><myDatePicker v-model="search.datearea_id" @onChange="onDateChange"></myDatePicker></div>
                    <div class="mg-top5"><el-button size="small" @click="list()">{{$t('list')}}</el-button></div>
                </div>
                <div class="mg-top5 mg-bottom5 flex-box nopadding">
                    <myEcharsCol :rows="chart_data.rows" :line_value_key="chart_data.line_value_key" height="250px"
                                 :name_key="chart_data.name_key" :value_key="chart_data.value_key"></myEcharsCol>
                </div>
            </div>
            <div class="fillw fillh">
                <el-table :data="listData" class="fillw" height="100%">
                    <el-table-column :label="listHeader.date_no" width="110px">
                        <el-table-column label-class-name="f-red pd-top0" width="110px">
                            <div slot-scope="scope" slot="header">合计</div>
                            <div class="f-bd" slot-scope="scope">{{scope.row.date_no}}</div>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column :label="listHeader.start_api_use_qty" min-width="120px">
                        <div class="f-bd" slot-scope="scope">{{scope.row.start_api_use_qty}}次</div>
                    </el-table-column>
                    <el-table-column :label="listHeader.mv_api_use_qty">
                        <el-table-column label-class-name="f-red pd-top0" min-width="120px">
                            <div slot-scope="scope" slot="header">{{totalData.sum.mv_api_use_qty * 1}}</div>
                            <div class="f-bd f-red" slot-scope="scope">{{scope.row.mv_api_use_qty}}次</div>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column :label="listHeader.end_api_use_qty" min-width="120px">
                        <div class="f-bd" slot-scope="scope">{{scope.row.end_api_use_qty}}次</div>
                    </el-table-column>
                    <el-table-column :label="listHeader.upd_time" prop="upd_time" width="150px"></el-table-column>
                </el-table>
            </div>
            <div slot="footer">
                <myPager slot="footer" :limit="search.limit" @onLimitChange="onLimitChange"
                         v-model="search.page" :pageSize="search.pageSize" @onPagerChange="onPagerChange"></myPager>
            </div>
        </myPage>
    </div>
</template>

<script>
import myPager from '../../../components/myPager'
import myDatePicker from "../../../components/myDatePicker";
import myEcharsCol from "../../../components/myEcharsCol";
import excel from '../../../utils/excel'
export default {
    name:'report-api',
    components:{
        myPager,
        myDatePicker,
        myEcharsCol
    },
    data: function(){
        const listHeader = {
            date_no: '账期',
            start_api_use_qty: '期初API调用量',
            mv_api_use_qty: '本期API调用量',
            end_api_use_qty: '期末API调用量',
            upd_time: '结算时间'
        }
        return{
            relist: false,
            search:{
                search_url: 'report-api/list',
                datearea_id:5,//如果大于0 mounted 要删除date_fr date_to
                date_fr: '',
                date_to: '',
                page: 1,
                pageSize: 0,
                limit:'30'
            },
            listHeader,
            listData:[],
            totalData: {
                total: 0,//总行数
                sum:{}
            },
            chart_data: {
                value_key:'mv_api_use_qty',
                name_key:'date_no',
                line_value_key:'avg_api_use_qty',
                rows: [],
            }
        }
    },
    activated:function(){
        this.$base.setMenuOpens();
    },
    mounted:function(){
        this.$base.setMenuOpens();
        this.$base.listPageInit(this,()=>{
            this.list();
        });
    },
    methods: {
        onDateChange: function(data){
            this.search.date_fr = data[0];
            this.search.date_to = data[1];
        },
        onPagerChange: function () {
            this.list(true);
        },
        onLimitChange: function (limit) {
            this.search.limit = limit;
            this.list();
        },
        getChartData: function () {
            this.$base.showLoading();
            this.$request.sendPost("report-api/get-chart-data",this.search,(success,data,error)=>{
                this.$base.hideLoading();
                if(success){
                    this.chart_data.rows = data.list;
                }
                else{
                    this.$base.alertErr(error.errmsg);
                }
            });
        },
        list: function (change_page) {
            if (!change_page) {
                this.getChartData();
            }
            this.$base.list(this, change_page);
        },
        exportExcel: function(){
            // this.$base.exportExcel(this);
            excel.exportExcel(this);
        },
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/report/api/list.vue